import React, { useState } from "react";
import {
  PDFDownloadLink,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
} from "@react-pdf/renderer";
import { useParams, useHistory, useLocation } from "react-router-dom";
import styles from "./ExportReportPage.module.css";

import { Download } from "react-ikonate";

export function ExportReportPage() {
  let { incidentNumber } = useParams();
  let location = useLocation();

  var reportData = {
    victimInfo: {
      name: location.state.victim.name,
      IboNumber: location.state.victim.number,
      email: location.state.victim.email,
      phoneNumber: location.state.victim.phoneNumber,
      username: location.state.victim.username,
      address: location.state.victim.address,
      city: location.state.victim.city,
      state: location.state.victim.state,
      zip: location.state.victim.zip,
      membershipStatus: location.state.victim.membershipStatus,
    },
    aggressorInfo: {
      name:
        location.state.aggressor.firstName +
        " " +
        location.state.aggressor.lastName,
      IboNumber: location.state.aggressor.iboNumber,
      email: location.state.aggressor.email,
      phoneNumber: location.state.aggressor.phoneNumber,
      username: location.state.aggressor.username,
      address: location.state.aggressor.address,
      city: location.state.aggressor.city,
      state: location.state.aggressor.state,
      zip: location.state.aggressor.zip,
      membershipStatus: location.state.aggressor.membershipStatus,
    },
    incidentDetails: {
      incidentNumber: incidentNumber,
      status: location.state.case.status,
      type: location.state.aggressor.problemType,
      caseOwner: location.state.case.owner,
      dateCreated: location.state.case.createdAt,
      severity: location.state.case.severity,
      description: location.state.documentation.description,

      startDate:
        location.state.aggressor.startDate.month +
        " " +
        location.state.aggressor.startDate.day +
        ", " +
        location.state.aggressor.startDate.year,
      location: location.state.aggressor.problemLocation,
      subLocation: location.state.aggressor.subLocation,
      violationOfAgreement: location.state.aggressor.hasViolated ? "Yes" : "No",
      fromUpline: location.state.aggressor.fromUpline ? "Yes" : "No",
      attemptedResolution: location.state.aggressor.attemptedResolution
        ? "Yes"
        : "No",
      actionsTakenToResolve: location.state.aggressor.actionsTakenToResolve,
    },
    notes: location.state.notes,
    communicationLog: location.state.communications,
    calendarEvents: location.state.events,
  };

  let history = useHistory();

  function toCapitalizedWords(name) {
    var words = name.match(/[A-Za-z][a-z]*/g) || [];
    return words.map(capitalize).join(" ");
  }
  function capitalize(word) {
    return word.charAt(0).toUpperCase() + word.substring(1);
  }
  function displayObject(obj) {
    let str = "";
    for (let x in obj) {
      str += toCapitalizedWords(x) + ": " + obj[x] + "\n";
    }

    if (str == "") {
      str = "No information available under this category\n";
    }

    return str;
  }

  const pdfStyles = StyleSheet.create({
    page: {
      display: "flex",
      flexDirection: "row",
    },
    section: {
      margin: "20px",
      padding: "20px",
      display: "flex",
      flexDirection: "column",
    },
    title: {
      textDecoration: "underline",
      marginBottom: "20px",
      fontWeight: 100,
    },
    text: {
      whiteSpace: "pre-line",
      lineBreak: "anywhere",
      marginBottom: "20px",
    },
    row: {
      marginBottom: "10px",
    },
    listText: {
      whiteSpace: "pre-line",
      lineBreak: "anywhere",
      marginBottom: "20px",
    },
    listItem: {
      marginBottom: "10px",
    },
  });

  const PDF = () => (
    <Document>
      <Page size="A4" style={pdfStyles.page}>
        <View style={pdfStyles.section}>
          <Text style={pdfStyles.title}>INCIDENT REPORT</Text>

          <Text style={pdfStyles.title}>PRIMARY IBO INFO</Text>
          <Text style={pdfStyles.text}>
            {displayObject(reportData.victimInfo)}
          </Text>

          <Text style={pdfStyles.title}>COMPLAINT AGAINST INFO</Text>
          <Text style={pdfStyles.text}>
            {displayObject(reportData.aggressorInfo)}
          </Text>

          <Text style={pdfStyles.title}>INCIDENT DETAILS</Text>
          <Text style={pdfStyles.text}>
            {displayObject(reportData.incidentDetails)}
          </Text>

          <Text style={pdfStyles.title}>NOTES</Text>
          <View style={pdfStyles.listText}>
            {reportData.notes.map((item, index) => {
              const { files, ...noteData } = item;
              const itemContent = Object.keys(noteData)
                .map(
                  (key, index) =>
                    `${index !== 0 ? "\u00a0\u00a0" : ""}${capitalize(key)}: ${
                      item[key]
                    }\n`
                )
                .join("");
              return (
                <Text style={pdfStyles.listItem} key={index}>
                  {"\u2022 "}
                  <Text style={pdfStyles.listContent}>{itemContent}</Text>
                </Text>
              );
            })}
          </View>

          <Text style={pdfStyles.title}>COMMUNICATION LOG</Text>
          <Text style={pdfStyles.text}>
            {reportData.communicationLog.map((item, index) => {
              return (
                <Text style={pdfStyles.listItem}>
                  {"\u2022 "}
                  {Object.keys(item).map((key, index) => {
                    return (
                      <Text style={pdfStyles.listContent}>
                        {index !== 0 && "\u00a0\u00a0"}
                        {capitalize(key)}: {item[key]}
                        {"\n"}
                      </Text>
                    );
                  })}
                </Text>
              );
            })}
          </Text>

          <Text style={pdfStyles.title}>CALENDAR EVENTS</Text>
          <Text style={pdfStyles.text}>
            {reportData.calendarEvents.map((item, index) => {
              return (
                <Text style={pdfStyles.listItem}>
                  {"\u2022 "}
                  {Object.keys(item).map((key, index) => {
                    return (
                      <Text style={pdfStyles.listContent}>
                        {index !== 0 && "\u00a0\u00a0"}
                        {capitalize(key)}: {item[key]}
                        {"\n"}
                      </Text>
                    );
                  })}
                </Text>
              );
            })}
          </Text>
        </View>
      </Page>
    </Document>
  );

  return (
    <div className={styles.container}>
      <div className={styles.report}>
        <PDF />
      </div>

      <div className={styles.card}>
        <PDFDownloadLink
          document={<PDF />}
          fileName={`incident_${incidentNumber}`}
          className={styles.cardItem}
        >
          <div className={styles.icon}>
            <Download />
          </div>
          Download
        </PDFDownloadLink>

        <div className={styles.button} onClick={() => history.goBack()}>
          Back
        </div>
      </div>
    </div>
  );
}
